'use strict';

// TODO; semver-major: remove

module.exports = require('call-bind/callBound');



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/callBound.js
// module id = 475
// module chunks = 0